var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import render from 'utils/render';
const SvgLoyalfansLogo = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    children,
    ...props
  } = _ref;
  const Element = render.element(/*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 182 28",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7748_7548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.1622 4.96777C23.8438 4.96777 18.7891 10.1162 18.7891 16.3484C18.7891 22.5807 23.9341 27.7291 30.1622 27.7291C36.3904 27.7291 41.5354 22.5807 41.5354 16.3484C41.5354 10.1162 36.3904 4.96777 30.1622 4.96777ZM30.1622 23.7549C26.1004 23.7549 22.7606 20.4129 22.7606 16.3484C22.7606 12.2839 26.1004 8.94197 30.1622 8.94197C34.2241 8.94197 37.5638 12.2839 37.5638 16.3484C37.5638 20.4129 34.2241 23.7549 30.1622 23.7549Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6527 4.96777V23.3936H99.1232V27.7291H83.959V4.96777H88.6527Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3477 7.8576L49.5687 21.5866V27.7286H53.5403V21.5866L68.4337 0.270508L51.735 14.7221L42.3477 7.8576Z",
    fill: "#D90A16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7354 11.4711C53.1312 11.4711 54.2627 10.3389 54.2627 8.94212C54.2627 7.54537 53.1312 6.41309 51.7354 6.41309C50.3395 6.41309 49.208 7.54537 49.208 8.94212C49.208 10.3389 50.3395 11.4711 51.7354 11.4711Z",
    fill: "#D90A16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.35 4.96777V9.30326H108.601V14.3613H116.905V18.6968H108.601V27.7291H104.269V4.96777H118.35Z",
    fill: "#D90A16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.404 4.96777V27.7291L146.601 14.3613V27.7291H142.269V4.96777L157.072 18.3355V4.96777H161.404Z",
    fill: "#D90A16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.042 14C172.688 13.3678 171.514 12.5549 171.514 11.471C171.514 10.7484 171.695 10.1162 172.237 9.66455C172.598 9.30326 173.32 8.94197 174.403 8.94197C175.847 8.94197 177.652 9.30326 179.458 10.3871L180.902 7.13552C179.728 6.41293 177.652 4.96777 173.681 4.96777C171.514 4.96777 169.709 5.69035 168.626 6.77423C167.543 7.8581 166.821 9.66455 166.821 11.471C166.821 12.9162 167.182 14 167.904 15.0839C168.716 16.3484 170.702 17.5226 172.146 18.1549C173.681 18.7871 176.028 19.3291 176.118 21.2258C176.118 21.9484 175.937 22.5807 175.396 23.0323C175.035 23.3936 174.313 23.7549 173.229 23.7549C171.785 23.7549 169.98 23.3936 168.175 22.3097L166.73 25.5613C167.723 27.0065 175.757 29.4452 179.006 25.9226C180.36 24.4775 180.812 23.0323 180.812 21.2258C180.812 19.7807 180.18 18.3355 179.728 17.6129C178.826 16.4387 177.201 15.3549 174.042 14Z",
    fill: "#D90A16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.682 27.7291L124.126 24.1162H131.709L133.153 27.7291H138.208L128.459 4.96777H128.098L118.35 27.7291H122.682ZM128.098 14.7226L130.264 20.142H125.932L128.098 14.7226Z",
    fill: "#D90A16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.733 27.7291L66.1772 24.1162H73.8496L75.2938 27.7291H80.3485L70.6001 4.96777H70.2391L60.4004 27.7291H64.733ZM70.2391 14.7226L72.4054 20.142H68.0728L70.2391 14.7226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.06896 4.96777V23.3936H15.5395V27.7291H0.736328V4.96777H5.06896Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7748_7548"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180.526,
    height: 28,
    fill: "white",
    transform: "translate(0.736328)"
  }))))));
  return /*#__PURE__*/React.createElement(Element.type, _extends({}, Element.props, {
    ref: ref
  }), children, Element.props.children);
});
export default /*#__PURE__*/React.memo(SvgLoyalfansLogo);